/* eslint-disable */
import * as React from "react";
export const createEmitter = () => {
    const listeners = [];
    return {
        emit(event) {
            listeners.forEach((listener) => listener(event));
        },
        subscribe(listener) {
            listeners.push(listener);
            return () => {
                listeners.splice(listeners.indexOf(listener), 1);
            };
        },
    };
};
export const createEnvironmentInterface = () => {
    const environmentInterfaceContext = React.createContext(null);
    const useEnvironmentInterface = () => React.useContext(environmentInterfaceContext);
    const EnvironmentInterfaceProvider = ({ environment, children }) => {
        return (React.createElement(environmentInterfaceContext.Provider, { value: environment }, children));
    };
    return {
        useEnvironmentInterface,
        EnvironmentInterfaceProvider,
        EnvironmentInterfaceConsumer: environmentInterfaceContext.Consumer,
    };
};
//# sourceMappingURL=index.js.map